import React from 'react';
import Logo from '@codedrop/logo/esm/logo';
import TopBar from '@codedrop/topbar/esm/topbar';
import MainMenu from '@codedrop/main-menu/esm/main-menu';

const Header = ({
  header
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "header__wrapper"
  }, /*#__PURE__*/React.createElement(TopBar, {
    topbar: header.topbar
  }), /*#__PURE__*/React.createElement("header", {
    className: "header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__inner"
  }, /*#__PURE__*/React.createElement(Logo, {
    logo: header.logo
  }), /*#__PURE__*/React.createElement(MainMenu, {
    mainMenu: header.mainMenu
  }))));
};

Header.displayName = 'Header';
export default Header;